<template>
    <div ref="dialog" class="modal fade">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Pickup Location</h4>
                    <button type="button" class="close" data-dismiss="modal" @click="quit"><i class="fa fa-times"></i></button>
                </div>
                <div class="modal-body" :class="(inProgress?'processing':'')">
                    <form class="row">
                        <!--div class="form-group col-md-8 pr-md-1">
                            <label for="dCity">Restaurant</label>
                            <select class="form-control" id="dCity" v-model="city">
                                <option v-for="city in cities" v-bind:value="city.val" v-bind:key="city.val">{{city.name}}</option>
                            </select>
                        </div-->
                        <div class="form-group col-md-12">
                            <label for="dTime">Pickup time</label>
                            <select class="form-control" id="dTime" v-model="time">
                                <option v-for="tm in timelist" v-bind:value="tm" v-bind:key="tm">{{tm}}</option>
                            </select>
                        </div>
                    </form>
                    <div class="progressor"></div>
                    <div class="note">{{notification}}</div>
                </div>
                <div class="modal-footer">
                    <button :disabled="inProgress" type="button" class="btn btn-primary" @click="proceed">Continue</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//    import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
    import axios from '../lib/McAxios';
    import _ from 'underscore'
    export default {
        name: 'Delivery',
        props: {
        },
        data: function () {
            return {
                cities: [],
                city: 'Take away',
                street: '',
                building: '',
                appartment: '',
                suggest: [],
                time: '',
                timelist: [],
                selectedAddress: null,
                inProgress: false,
                notification: 'Select the restaurant and time of pickup'
            }
        },
        components: {
//            VueBootstrapTypeahead
        },
        mounted() {
            this.cities = [
                {val:'Take away', name:'Take away from The Prancing Pony Pub'},
                {val:'London', name:'London: Some Street, 344, NE3 1AW'},
                {val:'Aberdeen', name:'Aberdeen: 1 Union Terrace, AB10 1NJ'},
                {val:'Birmingham', name:'Birmingham: St Martins Square, 6 Spiceal St, B5 4BW'}
            ]
            this.timelist=[];
            let time= new Date();
            let delay = 1
            let interval = 30
            time.setTime(time.getTime() + (delay*60*60*1000));
            let h= time.getHours()
            let m = time.getMinutes()
            time.setMinutes((Math.round(m/interval) * interval) % 60);
            time.setHours(((((m/(120-interval)) + .5) | 0) + h) % 24)
            for (let i = 0; i <= (6 * (60/interval)); i++) {
//                if ( time.getHours()<23 && time.getHours()>9) {
                    this.timelist.push(time.getHours()+':'+ ("0" + time.getMinutes()).substr(-2) );
                    time.setMinutes(time.getMinutes() + interval);
//                }
            }
        },
        methods: {
            proceed() {
                window.$(this.$refs.dialog).modal('hide');
                this.$store.dispatch('requestAddress',false)
                this.$store.dispatch('tryToRecover')
            },
            quit () {
                this.$store.dispatch('requestAddress',false)
            },
            updateAddress () {
                console.log(this.cities)
                console.log(this.city)
                console.log(this.cities.find(element=>{
                    return element.val==this.city
                }))
                let address = {
                    "shippingAddress": {
                        "firstName": this.$store.state.completeData.firstName,
                        "lastName": this.$store.state.completeData.lastName,
                        "countryCode": "GB",
                        "street": this.cities.find(element=>{
                            return element.val==this.city
                        }).name,
                        "city": this.city,
                        "postcode": ""
                    }
                }
                this.inProgress = true
                axios.put( '/shop-api/checkout/'+this.$store.state.token+'/address', address)
                    .then(()=>{
                        axios.get( '/shop-api/checkout/'+this.$store.state.token+'/shipping' )
                            .then(response => {
                                this.inProgress = false
                                if (response.data.shipments.length) {
                                    let keys = Object.keys(response.data.shipments[0].methods);
                                    if (keys.includes('TAKEAWAY')) {
                                        this.notification = 'You can place an order and pick it up at from this location'
                                        this.$store.dispatch('updateDelivery', [0, 'TAKEAWAY'])
                                    } else {
                                        this.notification = 'Unfortunately we are not able to take the order'
                                    }
                                }
                            })
                            .catch(()=>{
                                this.inProgress = false
                                this.notification = 'Unfortunately we are not able to take the order'
                            })
                    })
                    .catch(()=>{
                        this.inProgress = false
                        this.notification = 'Something went wrong. Requested location was not found'
                    })
            }

        },

        computed: {
            showDialog() {
                return  this.$store.state.requestAddress
            },
        },
        watch: {
            showDialog(newValue) {
                if (newValue) {
                    if (this.$store.state.cart.shippingAddress) {
                        this.city = this.$store.state.cart.shippingAddress.city
                        this.street = this.$store.state.cart.shippingAddress.street
                    }
                    window.$(this.$refs.dialog).modal('show');
                }
            },

            city: _.debounce( function() {
                this.updateAddress()
            }, 100),

            time: _.debounce( function() {
                this.updateAddress()
                this.$store.dispatch('setPickupTime', this.time)
            }, 100),
        }
    }

</script>